import { jsx as _jsx } from "react/jsx-runtime";
import { MSystemGroup } from '@svenskaspelab/ui/react/bet-button';
import { useMemo } from 'react';
import { cn } from '../utils/entry.js';
import convertOutcomeCountToLabels from './convertOutcomeCountToLabels.js';
/**
 * This component is responsible for rendering the correct amount of outcomes and converting the outcome count to correct labels.
 *
 * @param root0 Component that displays the outcome.
 * @param root0.className Classname for the component
 * @param root0.selectedOutcomes Array with selected outcomes
 * @param root0.outcomeCount Number of outcomes
 * @param root0.renderItem Function to render the outcome
 * @param root0.localDistribution Optional local distribution for outcome labels
 * @param root0.onChange Callback function triggered when an outcome is selected
 * @returns Component that displays the outcome.
 */
export default function CouponEventOutcomes({
  className,
  outcomeCount,
  selectedOutcomes,
  renderItem,
  localDistribution,
  onChange
}) {
  const outcomeLabels = useMemo(() => convertOutcomeCountToLabels(outcomeCount, localDistribution), [outcomeCount, localDistribution]);
  // z-index fix for betbuttons since overlapping link-area causes issues with clicking when in multi coupon mode in desktop
  // `[&>div]:my-0 [&>div]:py-0` neutralizes the `-my-2 py-2` on each BetButton wrapper so the
  // outcomes row hugs the buttons instead of inheriting the extra ~16px from packages/ui.
  return _jsx(MSystemGroup, {
    className: cn('z-2 w-fit justify-between [grid-area:betButtons] lg:min-w-[150px] [&>div]:my-0 [&>div]:py-0 lg:[&>div]:w-full', className),
    children: outcomeLabels.map(({
      ariaLabel,
      outcome
    }, index) => renderItem({
      isSelected: selectedOutcomes?.length ? selectedOutcomes.includes(index) : false,
      outcome: localDistribution && localDistribution[index] !== undefined ? `${localDistribution[index]}%` : outcome,
      index,
      isEmptyOutcome: !outcome && !ariaLabel,
      onButtonChange: onChange ? (buttonIndex, currentCouponIndex) => {
        onChange(buttonIndex, currentCouponIndex);
      } : undefined
    }))
  });
}